import { cn } from '@/lib/utils';

import styles from './AnimatedBackground.module.css';

type Props = {
  animated?: boolean;
  className?: string;
};

export function HeroBackground({ animated = true, className }: Props) {
  return (
    <svg
      className={cn('w-full', className)}
      viewBox='0 0 1440 1106'
      fill='none'
      preserveAspectRatio='xMidYMid slice'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        className={animated ? styles.path : ''}
        d={fromPath}
        stroke='url(#paint0_linear_1209_45508)'
        stroke-width='2'
        stroke-miterlimit='10'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1209_45508'
          x1='1069'
          y1='1'
          x2='1069'
          y2='1105'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#25CE73' />
          <stop offset='0.16' stopColor='#00FFF7' />
          <stop offset='0.335' stopColor='#346AFF' />
          <stop offset='0.525' stopColor='#F13FFF' />
          <stop offset='0.695' stopColor='#F96A6F' />
          <stop offset='0.855' stopColor='#E47018' />
          <stop offset='1' stopColor='#EFBC5B' />
        </linearGradient>
      </defs>
    </svg>
  );
}

const fromPath = `M2672 1105C1219.79 1105.25 918.174 1038.21 -534 1038.46M2672 1105C1219 1105.23 918.997 934.477 -534 934.704M2672 1105C1218.18 1105.2 919.786 830.768 -534 830.971M2672 1105C1217.39 1105.18 920.609 727.06 -534 727.212M2672 1105C1216.57 1105.15 921.398 623.326 -534 623.478M2672 1105C1215.78 1105.13 922.222 519.618 -534 519.719M2672 1105C1214.96 1105.1 923.011 415.884 -534 415.985M2672 1105C1214.17 1105.08 923.834 312.176 -534 312.252M2672 1105C1213.34 1105.05 924.623 208.442 -534 208.493M2672 1105C1212.55 1105 925.446 104.734 -534 104.759M2672 1105C1211.73 1105 926.235 1 -534 1`;
